export const PRODUCT_NAME = "Outfame"
export const SUPER_ADMIN_EMAIL = "dragos.balan.pr@gmail.com"
export const ADMIN_USER_LIST_VIEW_PAGE_SIZE = 10
export const ADMIN_ORGANIZATION_LIST_VIEW_PAGE_SIZE = 10

export const ROOT_DOMAIN = process.env.NODE_ENV === "production" ? "outfame.com" : "localhost:3002"
export const APP_DOMAIN = `${ROOT_DOMAIN}/app`
export const DEV_PORT = `3002`
export const PROTOCOL = process.env.NODE_ENV === "production" ? "https" : "http"
export const ROOT_URL_PATH = `${PROTOCOL}://${process.env.NODE_ENV === "production" ? `www.${ROOT_DOMAIN}` : ROOT_DOMAIN}`

export const BLOG_POSTS_PER_PAGE = 12

export const DEMO_USER_EMAIL = "demo@outfame.com"
export const DEMO_USER_ID = "18d0890b-b1d6-47e8-be62-82d313fe20c8"
export const DEMO_ACCOUNT_ID = "654c6b38-2235-402b-85f9-823e3da306e9"
export const DEMO_ACCOUNT_IDS = ["654c6b38-2235-402b-85f9-823e3da306e9", "c7a8face-cc36-4505-9cb1-78b6a49354a6", "06986620-54f0-444d-9fff-b92495c92680"]

export const enabledLocales = ["en", "es", "fr", "de"]

/**
 * Pages that have real locale variants (es/de/fr translations).
 * Pages NOT in this set are English-only — no hreflang, no locale URL variants.
 * Update this set when new pages get fully translated.
 */
export const LOCALIZED_PAGES = new Set([
    "",
    "/pricing",
    "/outfame-reviews",
    "/start",
    "/sign-up",
    "/how-it-works",
    "/about",
    "/contact",
    "/careers",
    "/results",
    "/switch-to-outfame",
    "/gift",
    "/affiliate-program",
    "/buy-instagram-followers",
    "/buy-instagram-likes",
    "/buy-instagram-views",
    "/free-instagram-followers",
    "/instagram-growth-service",
    "/instagram-growth-comparison",
    "/instagram-targeting",
    "/safe-instagram-growth",
    "/real-instagram-followers",
    "/instagram-analytics",
    "/instagram-automation",
    "/instagram-bot",
    "/chatgpt-for-instagram",
    "/influencer-marketing-guide",
    "/login",
    "/forgot-password",
    "/terms-of-service",
    "/privacy",
    "/newsroom",
    "/reviews",
])

export const globalMetadata = {
    siteName: "Outfame",
    siteUrl: `https://www.outfame.com`,
    siteLogo: "https://www.outfame.com/img/outfame-logo.png",
    email: "support@outfame.com",
    description: `Outfame is the best AI Instagram growth service that helps you grow your Instagram account organically and automatically.`
}

export const targetingOptionsDefault = {
    features: {
        like: true,
        story_views: true,
        comment_like: true,
        other: true
    },
    general: {
        speed: "slow",
        gender: "any"
    },
    interests: {},
    locations: {
        canada: true,
        europe: true,
        "united-states": true
    }
}

export const competitorList = [
    {
        name: "Path Social",
        showInFooter: true,
        url: "https://www.pathsocial.com",
        description: `Seller describes influencer shoutouts, newsletters, organic promotion, and AI profile review. The reviewed offer uses a public profile and annual billing.`
    },
    {
        name: "Nitreo",
        showInFooter: true,
        url: "https://nitreo.com",
        description: `Seller describes automated follows, likes, Story views, and targeting. Its published terms require a username and password.`
    },
    {
        name: "Ingramer",
        showInFooter: true,
        url: "https://ingramer.com",
        description: `While Ingramer is another Instagram growth tool, Outfame offers a more effective and safer organic Instagram growth service. Our advanced AI technology targets the most relevant and engaged users, resulting in more real followers and better engagement rates. Plus, our service is more affordable than Ingramer, allowing you to save money while achieving your growth goals.`
    },
    {
        name: "Kicksta",
        showInFooter: true,
        url: "https://kicksta.co",
        description: `Seller describes AI growth pods, competitor and hashtag targeting, and a 7-day trial. Its reviewed pricing page displays monthly, quarterly, and annual options and requires an Instagram login and password.`
    },
    {
        name: "Instagress",
        showInFooter: true,
        url: "https://instagress.com",
        description: `Instagress used to be a popular Instagram growth tool, but it's no longer in operation. Looking for a new solution? We'll compare Instagress's features and pricing to Outfame, the AI-powered Instagram growth service that delivers real, organic growth.`
    },
    {
        name: "Jarvee",
        showInFooter: true,
        url: "https://jarvee.com",
        description: `Jarvee is an automation tool that claims to help grow your Instagram account. But how does it compare to Outfame? In this comparison, we'll dive into the details to help you make an informed decision about which service is the best fit for your growth goals.`
    },
    {
        name: "Plixi",
        showInFooter: true,
        url: "https://plixi.com",
        description: `Seller describes paid advertising, niche data, human activity, and AI targeting. The reviewed offer uses a public profile and displays annual pricing.`
    },
    {
        name: "Combin",
        showInFooter: true,
        url: "https://combin.com",
        description: `Combin is an Instagram growth service that claims to deliver real, organic followers. But is it the best option for your business? In this comparison, we'll take a closer look at how Combin stacks up against Outfame, the AI-powered Instagram growth service that delivers real, organic growth.`
    },
    {
        name: "Twicsy",
        url: "https://twicsy.com",
        description: `Twicsy is an Instagram service that claims to deliver real, organic followers. But is it the best option for your business? In this comparison, we'll take a closer look at how Twicsy stacks up against Outfame, the AI-powered Instagram growth service that delivers real, organic growth.`
    },
    {
        name: "Buzzoid",
        url: "https://buzzoid.com",
        description: `Buzzoid is an Instagram service that claims to deliver real likes and followers. But is it the best option for your business? In this comparison, we'll take a closer look at how Buzzoid stacks up against Outfame, the AI-powered Instagram growth service that delivers real, organic growth.`
    },
    {
        name: "RiseKarma",
        url: "https://risekarma.com",
        description: `RiseKarma is an Instagram  service that claims to deliver real likes, followers and comments. But is it the best option for your business? In this comparison, we'll take a closer look at how RiseKarma stacks up against Outfame, the AI-powered Instagram growth service that delivers real, organic growth.`
    },
    {
        name: "Gramto",
        url: "https://gramto.com",
        description: `If you're looking for a tool to help you grow your Instagram followers, consider Outfame instead. Our AI-powered growth strategy targets real, active users who are more likely to engage with your content and become loyal followers. Additionally, our service is more affordable than Gramto, allowing you to save money while still achieving your growth goals.`
    },
    {
        name: "SocialSteeze",
        url: "https://socialsteeze.com",
        description: `SocialSteeze may be another Instagram growth tool, but Outfame offers a safer and more effective growth strategy. We use only organic growth strategies and do not violate any Instagram rules. This means you can achieve faster and more significant growth results without the risk of Instagram account bans or suspensions. Additionally, our service is more affordable than SocialSteeze, allowing you to save money while achieving your growth goals.`
    },
    {
        name: "SocialBoost",
        url: "https://socialboost.co",
        description: `Social Boost is a competitor in the Instagram growth service space, but Outfame offers several advantages. We use advanced AI algorithms to target the most relevant and engaged users, resulting in more real followers and better engagement rates. Additionally, our service is more affordable and offers better customer support than Social Boost.`
    },
    {
        name: "SocialMonk",
        url: "https://socialmonk.net",
        description: `While SocialMonk may be another Instagram growth tool, Outfame offers a more effective and safer organic Instagram growth service. Our advanced AI technology targets the most relevant and engaged users, resulting in more real followers and better engagement rates. Plus, our service is more affordable than SocialMonk, allowing you to save money while achieving your growth goals.`
    },
    {
        name: "SimplyGram",
        url: "https://simplygram.com",
        description: `If you're considering SimplyGram for your Instagram growth needs, consider Outfame instead. Our AI-powered growth strategy targets real, active users who are more likely to engage with your content and become loyal followers. Additionally, our service is more affordable than SimplyGram, allowing you to save money while still achieving your growth goals.`
    },
    {
        name: "Kenji",
        url: "https://kenji.ai",
        description: `Kenji is a popular Instagram growth tool that promises to help users gain real followers, increase engagement, and save time. However, our team at Outfame has found that Kenji's growth strategy relies on outdated automation techniques that can put your account at risk of being flagged by Instagram. If you're looking for a safer, more effective way to grow your Instagram following, check out Outfame.`
    },
    {
        name: "RiseSocial",
        url: "https://risesocial.com",
        description: `RiseSocial claims to be an Instagram growth service that can help users gain real followers and improve engagement. However, our team at Outfame has found that RiseSocial uses outdated automation techniques that can put your account at risk of being flagged by Instagram. If you're looking for a safer, more effective way to grow your Instagram following, check out Outfame.`
    },
    {
        name: "SueVu",
        url: "https://suevu.com",
        description: `SueVu is an Instagram growth tool that promises to help users gain real followers and increase engagement. However, our team at Outfame has found that SueVu relies on automated bots and outdated growth strategies that can put your account at risk of being flagged by Instagram. If you're looking for a safer, more effective way to grow your Instagram following, check out Outfame.`
    },
    {
        name: "SocialSensei",
        url: "https://socialsensei.com",
        description: `SocialSensei claims to be a premium Instagram growth service that can help users gain real, engaged followers. However, our team at Outfame has found that SocialSensei relies on automated bots and outdated growth strategies that can put your account at risk of being flagged by Instagram. If you're looking for a safer, more effective way to grow your Instagram following, check out Outfame.`
    },
    {
        name: "NapoleonCat",
        url: "https://napoleoncat.com",
        description: `NapoleonCat is an all-in-one social media management tool that includes an Instagram growth feature. However, our team at Outfame has found that NapoleonCat's Instagram growth service relies on outdated automation techniques that can put your account at risk of being flagged by Instagram. If you're looking for a safer, more effective way to grow your Instagram following, check out Outfame.`
    },
    {
        name: "BigBangram",
        url: "https://bigbangram.com",
        description: `BigBangram is an Instagram growth tool that promises to help users gain real followers and improve engagement. However, our team at Outfame has found that BigBangram relies on automated bots and outdated growth strategies that can put your account at risk of being flagged by Instagram. If you're looking for a safer, more effective way to grow your Instagram following, check out Outfame.`
    },
    {
        name: "Instazood",
        url: "https://instazood.com",
        description: `Instazood is a popular Instagram growth service, but is it worth the investment? In this comparison, we'll take a closer look at how Instazood stacks up against Outfame, the AI-powered Instagram growth service that delivers real, organic growth.`
    },
    {
        name: "Instato",
        url: "https://instato.com",
        description: `Looking for an Instagram growth tool that delivers results? We'll compare Instato and Outfame to help you decide which service is the right choice for you. From pricing to features, we'll cover everything you need to know to make an informed decision.`
    },
    {
        name: "HypePlanner",
        url: "https://hypeplanner.com",
        description: `HypePlanner is an Instagram growth service that promises to help you grow your following. But is it the right choice for your business? In this comparison, we'll take a closer look at how HypePlanner stacks up against Outfame, the AI-powered Instagram growth service that delivers real, organic growth.`
    },
    {
        name: "Boostfy",
        url: "https://boostfy.com",
        description: `Boostfy is an Instagram growth tool that claims to deliver real, organic followers. But is it the right choice for your business? In this comparison, we'll take a closer look at how Boostfy stacks up against Outfame, the AI-powered Instagram growth service that delivers real, organic growth.`
    },
    {
        name: "SocialMeep",
        url: "https://socialmeep.com",
        description: `SocialMeep is an Instagram growth service that promises to help you grow your following. But is it the right choice for your business? In this comparison, we'll take a closer look at how SocialMeep stacks up against Outfame, the AI-powered Instagram growth service that delivers real, organic growth.`
    },
    {
        name: "Gramista",
        url: "https://gramista.com",
        description: `Gramista is an Instagram growth service that claims to provide real followers and likes, but we found that it fell short of our expectations. Are you looking for a better Instagram growth service that uses proven, organic strategies to help you achieve your growth goals? Look no further than Outfame. Read our comparison to learn why Outfame is the better choice for your Instagram growth needs.`
    },
    {
        name: "Upleap",
        url: "https://upleap.com",
        description: `Seller describes automated follows, likes, direct messages, Story views, and targeting. Its published terms require a username and password.`
    },
    {
        name: "WolfGrowth",
        url: "https://wolfgrowth.com",
        description: `Wolf Growth is another Instagram growth service that has gained popularity in recent years. While it may work for some users, we found that it lacked the effectiveness and safety that we were looking for. If you want to grow your Instagram followers safely and organically, Outfame is the way to go. Our AI-powered growth strategy targets real, active users who are more likely to engage with your content and become loyal followers. Plus, our service is more affordable and effective than Wolf Growth. Read our full feature and product comparison to learn more.`
    },
    {
        name: "Instamacro",
        url: "https://instamacro.com",
        description: `Instamacro used to be a popular Instagram growth service that provided automated likes, follows, and comments. However, since Instagram updated its algorithm, Instamacro's services are no longer effective. This is where Outfame comes in. Outfame provides an organic Instagram growth service that targets real and engaged users, resulting in increased engagement, growth, and sales. Read our honest review of Instamacro and why we believe Outfame is a better option for Instagram growth.`
    },
    {
        name: "Socinator",
        url: "https://socinator.com",
        description: `Socinator is an Instagram growth service that provides automated likes, follows, and comments. However, using these methods can be risky and result in Instagram account bans or suspensions. Outfame provides an organic Instagram growth service that targets real and engaged users, resulting in increased engagement, growth, and sales. Read our honest review of Socinator and why we believe Outfame is a safer and more effective option for Instagram growth.`
    },
    {
        name: "Managergram",
        url: "https://managergram.com",
        description: `Managergram is an Instagram growth service that provides automated likes, follows, and comments. However, these methods can be risky and result in Instagram account bans or suspensions. Outfame provides an organic Instagram growth service that targets real and engaged users, resulting in increased engagement, growth, and sales. Read our honest review of Managergram and why we believe Outfame is a safer and more effective option for Instagram growth.`
    },
    {
        name: "SocialCaptain",
        url: "https://socialcaptain.com",
        description: `SocialCaptain is an Instagram growth service that provides automated likes, follows, and comments. However, these methods can be risky and result in Instagram account bans or suspensions. Outfame provides an organic Instagram growth service that targets real and engaged users, resulting in increased engagement, growth, and sales. Read our honest review of SocialCaptain and why we believe Outfame is a safer and more effective option for Instagram growth.`
    },
    {
        name: "Inflact",
        url: "https://inflact.com",
        description: `Inflact is an Instagram growth service that provides automated likes, follows, and comments. However, these methods can be risky and result in Instagram account bans or suspensions. Outfame provides an organic Instagram growth service that targets real and engaged users, resulting in increased engagement, growth, and sales. Read our honest review of Inflact and why we believe Outfame is a safer and more effective option for Instagram growth.`
    },
    {
        name: "UseViral",
        url: "https://useviral.com",
        description: `UseViral is an Instagram growth service that provides automated likes, follows, and comments. However, these methods can be risky and result in Instagram account bans or suspensions. Outfame provides an organic Instagram growth service that targets real and engaged users, resulting in increased engagement, growth, and sales. Read our honest review of UseViral and why we believe Outfame is a safer and more effective option for Instagram growth.`
    },
    {
        name: "AiGrow",
        url: "https://aigrow.me",
        description: `AiGrow is an Instagram growth service that provides automated likes, follows, and comments. However, using these methods can be risky and result in Instagram account bans or suspensions. Outfame provides an organic Instagram growth service that targets real and engaged users, resulting in increased engagement, growth, and sales. Read our honest review of AiGrow and why we believe Outfame is a safer and more effective option for Instagram growth.`
    },
    {
        name: "AscendViral",
        url: "https://ascendviral.com",
        description: `Seller describes a manual Personal Growth Assistant and a 5-day trial. The published setup uses a password through an encrypted dashboard.`
    },
    {
        name: "MrInsta",
        url: "https://mrinsta.com",
        description: `MrInsta is an Instagram growth service that offers various growth options, including buying Instagram followers and likes. However, we found that these practices can be detrimental to your account's growth and reputation. In this review, we'll compare MrInsta with Outfame, a safer and more effective Instagram growth service that uses advanced AI technology to target real and engaged users.`
    },
    {
        name: "Heepsy",
        url: "https://heepsy.com",
        description: `Heepsy is a platform that claims to help businesses find influencers for their campaigns. However, we found that their search results are not always accurate, and their pricing plans can be expensive. In this review, we'll compare Heepsy with Outfame, an Instagram growth service that offers a more effective and affordable solution for businesses looking to grow their Instagram audience.`
    },
    {
        name: "Flock Social",
        url: "https://flocksocial.com",
        description: `Flock Social is retained as an existing comparison URL; its current offer details are outside the ranked ten-service review and should be verified directly.`
    },
    {
        name: "Eclincher",
        url: "https://eclincher.com",
        description: `Eclincher is a social media management tool that offers various features, including social media scheduling and analytics. However, their pricing plans can be expensive, and their Instagram growth service is not as effective as other dedicated growth services. In this review, we'll compare Eclincher with Outfame, a dedicated Instagram growth service that offers a more effective and affordable solution for businesses looking to grow their Instagram audience.`
    },
    {
        name: "SocialBuddy",
        url: "https://socialbuddy.com",
        description: `SocialBuddy is an Instagram growth service that claims to provide real and organic followers to its users. However, after trying their service, we found that their results were not as significant as we had hoped. In this review, we'll compare SocialBuddy with Outfame, a more effective and affordable Instagram growth service that uses advanced AI technology to target real and engaged users.`
    },

    {
        name: "Ampfluence",
        url: "https://ampfluence.com",
        description: `Seller describes human targeting and engagement services. Its published FAQ requires a username and password and has no verified public trial.`
    },
    {
        name: "UpGrow",
        url: "https://www.upgrow.com",
        showInFooter: false,
        description: `Seller describes AI plus human Instagram experts and claims real followers without a password.`
    },
    {
        name: "Sup Growth",
        url: "https://supgrowth.com",
        description: `Seller describes a person following, liking and commenting from the customer's account in their city and niche, with a 14-day free trial.`
    },
    {
        name: "Hexrate",
        url: "https://hexrate.io",
        description: `Seller describes automation, data analysis and audience discovery tools, says it never sells followers and does not require a password.`
    },
    {
        name: "MegaFollow",
        url: "https://megafollow.com",
        description: `Seller describes likes, comments and follows run around the clock from the customer's account, targeted by hashtag, location and similar accounts.`
    },
    {
        name: "Virallized",
        showInFooter: true,
        url: "https://www.virallized.com",
        description: `Seller describes manual human outreach outside the customer account and claims real targeted followers. Account access is not stated on the reviewed page.`
    },
    {
        name: "Growthoid",
        showInFooter: true,
        url: "https://growthoid.com",
        description: `Growthoid's former growthoid.com domain redirects to SidesMedia. Its current offer, account access, and relationship to similarly named domains are not verified here.`
    }
]

// Country names object using 2-letter country codes to reference country name
export const countryList = {
    AF: "Afghanistan",
    AL: "Albania",
    DZ: "Algeria",
    AD: "Andorra",
    AO: "Angola",
    AG: "Antigua and Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia and Herzegovina",
    BW: "Botswana",
    BR: "Brazil",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    CV: "Cabo Verde",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CO: "Colombia",
    KM: "Comoros",
    CD: "Congo",
    CG: "Congo",
    CR: "Costa Rica",
    HR: "Croatia",
    CU: "Cuba",
    CW: "Cura\u00e7ao",
    CY: "Cyprus",
    CZ: "Czechia",
    CI: "C\u00f4te d'Ivoire",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    SZ: "Eswatini",
    ET: "Ethiopia",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GR: "Greece",
    GD: "Grenada",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    VA: "Holy See",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IQ: "Iraq",
    IE: "Ireland",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KP: "Korea",
    KR: "Korea",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lao People's Democratic Republic",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    MK: "Republic of North Macedonia",
    RO: "Romania",
    RU: "Russian Federation",
    RW: "Rwanda",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia and the South Sandwich Islands",
    SS: "South Sudan",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard and Jan Mayen",
    SE: "Sweden",
    CH: "Switzerland",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania, United Republic of",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TO: "Tonga",
    TT: "Trinidad and Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States of America",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Viet Nam",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe"
}
export const countryEmojis = {
    "United States": "🇺🇸",
    India: "🇮🇳",
    "United Kingdom": "🇬🇧",
    Germany: "🇩🇪",
    Canada: "🇨🇦",
    France: "🇫🇷",
    Australia: "🇦🇺",
    Japan: "🇯🇵",
    Netherlands: "🇳🇱",
    Sweden: "🇸🇪",
    Brazil: "🇧🇷",
    Spain: "🇪🇸",
    Italy: "🇮🇹",
    Mexico: "🇲🇽",
    Indonesia: "🇮🇩",
    Russia: "🇷🇺",
    Turkey: "🇹🇷",
    Poland: "🇵🇱",
    Switzerland: "🇨🇭",
    Belgium: "🇧🇪",
    "South Africa": "🇿🇦",
    Argentina: "🇦🇷",
    Philippines: "🇵🇭",
    Malaysia: "🇲🇾",
    Nigeria: "🇳🇬",
    Chile: "🇨🇱",
    Colombia: "🇨🇴",
    "Saudi Arabia": "🇸🇦",
    Portugal: "🇵🇹",
    Romania: "🇷🇴",
    Greece: "🇬🇷",
    Hungary: "🇭🇺",
    Pakistan: "🇵🇰",
    Austria: "🇦🇹",
    Ukraine: "🇺🇦",
    "Czech Republic": "🇨🇿",
    Vietnam: "🇻🇳",
    Thailand: "🇹🇭",
    Bulgaria: "🇧🇬",
    Morocco: "🇲🇦",
    Peru: "🇵🇪",
    Moldova: "🇲🇩",
    Montenegro: "🇲🇪",
    Monaco: "🇲🇨",
    Luxembourg: "🇱🇺",
    Lithuania: "🇱🇹",
    Latvia: "🇱🇻",
    "United Arab Emirates": "🇦🇪",
    "South Korea": "🇰🇷",
    Ireland: "🇮🇪",
    Egypt: "🇪🇬",
    Israel: "🇮🇱",
    Singapore: "🇸🇬",
    Norway: "🇳🇴",
    Finland: "🇫🇮",
    Denmark: "🇩🇰",
    Croatia: "🇭🇷",
    "New Zealand": "🇳🇿",
    China: "🇨🇳",
    Venezuela: "🇻🇪",
    Qatar: "🇶🇦",
    Serbia: "🇷🇸",
    Slovakia: "🇸🇰",
    Belarus: "🇧🇾",
    Ecuardor: "🇪🇨",
    Slovenia: "🇸🇮",
    "Hong Kong": "🇭🇰",
    Bangladesh: "🇧🇩",
    Iraq: "🇮🇶",
    "Puerto Rico": "🇵🇷",
    "Bosnia and Herzegovina": "🇧🇦",
    Estonia: "🇪🇪",
    Georgia: "🇬🇪",
    Iceland: "🇮🇸",
    Jamaica: "🇯🇲",
    Maldives: "🇲🇻",
    Mauritius: "🇲🇺",
    Mauritania: "🇲🇷",
    Mongolia: "🇲🇳",
    Myanmar: "🇲🇲",
    Namibia: "🇳🇦",
    Nepal: "🇳🇵",
    "New Caledonia": "🇳🇨",
    Nicaragua: "🇳🇮",
    Niger: "🇳🇪",
    Niue: "🇳🇺",
    "Norfolk Island": "🇳🇫",
    "Northern Mariana Islands": "🇲🇼",
    Andorra: "🇦🇩",
    Bahrain: "🇧🇭",
    Angola: "🇦🇴",
    Albania: "🇦🇱",
    Algeria: "🇩🇿",
    Anguilla: "🇦🇮",
    Antarctica: "🇦🇶",
    "Antigua and Barbuda": "🇦🇬",
    Armenia: "🇦🇲",
    Aruba: "🇦🇼",
    Azerbaijan: "🇦🇿",
    Bahamas: "🇧🇸",
    Barbados: "🇧🇧",
    Belize: "🇧🇿",
    Benin: "🇧🇯",
    Bermuda: "🇧🇲",
    Bhutan: "🇧🇹",
    Bolivia: "🇧🇴",
    Botswana: "🇧🇼",
    "Burkina Faso": "🇧🇫",
    Burundi: "🇧🇮",
    Cambodia: "🇰🇭",
    Cameroon: "🇨🇲",
    "Cape Verde": "🇨🇻",
    "Cayman Islands": "🇰🇾",
    "Central African Republic": "🇨🇫",
    Chad: "🇹🇩",
    Comoros: "🇰🇲",
    Congo: "🇨🇬",
    "Democratic Republic of the Congo": "🇨🇩",
    "Costa Rica": "🇨🇷",
    "Côte d'Ivoire": "🇨🇮",
    Cuba: "🇨🇺",
    Cyprus: "🇨🇾",
    Djibouti: "🇩🇯",
    Dominica: "🇩🇲",
    "Dominican Republic": "🇩🇴",
    "El Salvador": "🇸🇻",
    "Equatorial Guinea": "🇬🇶",
    Eritrea: "🇪🇷",
    Ethiopia: "🇪🇹",
    Fiji: "🇫🇯",
    "French Guiana": "🇬🇫",
    "French Polynesia": "🇵🇫",
    "French Southern Territories": "🇹🇫",
    Gabon: "🇬🇦",
    Gambia: "🇬🇲",
    Ghana: "🇬🇭",
    Gibraltar: "🇬🇮",
    Greenland: "🇬🇱",
    Grenada: "🇬🇩",
    Guadeloupe: "🇬🇵",
    Guam: "🇬🇺",
    Guatemala: "🇬🇹",
    Guinea: "🇬🇳",
    "Guinea-Bissau": "🇬🇼",
    Guyana: "🇬🇾",
    Haiti: "🇭🇹",
    Vatican: "🇻🇦",
    Honduras: "🇭🇳",
    "Iran, Islamic Republic of": "🇮🇷",
    "Isle of Man": "🇮🇲",
    Jordan: "🇯🇴",
    Kazakhstan: "🇰🇿",
    Kenya: "🇰🇪",
    Kiribati: "🇰🇮",
    "Korea, Republic of": "🇰🇷",
    Kuwait: "🇰🇼",
    Kyrgyzstan: "🇰🇬",
    "Lao People's Democratic Republic": "🇱🇦",
    Lebanon: "🇱🇧",
    Lesotho: "🇱🇸",
    Liberia: "🇱🇷",
    Libya: "🇱🇾",
    Liechtenstein: "🇱🇮",
    Macao: "🇲🇴",
    "Macedonia, The Former Yugoslav Republic of": "🇲🇰",
    Madagascar: "🇲🇬",
    Malawi: "🇲🇼",
    Mali: "🇲🇱",
    Malta: "🇲🇹",
    Martinique: "🇲🇶",
    "Micronesia, Federated States of": "🇫🇲",
    Mozambique: "🇲🇿",
    Nauru: "🇳🇷",
    "Netherlands Antilles": "🇦🇳",
    Oman: "🇴🇲",
    Palau: "🇵🇼",
    "Palestinian Territory, Occupied": "🇵🇸",
    Panama: "🇵🇦",
    "Papua New Guinea": "🇵🇬",
    Paraguay: "🇵🇾",
    "Russian Federation": "🇷🇺",
    Rwanda: "🇷🇼",
    "Saint Barthélemy": "🇧🇱",
    "Saint Helena": "🇸🇭",
    "Saint Kitts and Nevis": "🇰🇳",
    "Saint Lucia": "🇱🇨",
    "Saint Martin": "🇲🇫",
    "Saint Pierre and Miquelon": "🇵🇲",
    "Saint Vincent and the Grenadines": "🇻🇨",
    Samoa: "🇼🇸",
    "San Marino": "🇸🇲",
    "Sao Tome and Principe": "🇸🇹",
    Senegal: "🇸🇳",
    Seychelles: "🇸🇨",
    "Sierra Leone": "🇸🇱",
    Somalia: "🇸🇴",
    "Sri Lanka": "🇱🇰",
    Sudan: "🇸🇩",
    Suriname: "🇸🇷",
    Swaziland: "🇸🇿",
    "Syrian Arab Republic": "🇸🇾",
    Taiwan: "🇹🇼",
    Tajikistan: "🇹🇯",
    "Tanzania, United Republic of": "🇹🇿",
    "Trinidad and Tobago": "🇹🇹",
    Tunisia: "🇹🇳",
    Turkmenistan: "🇹🇲",
    "Turks and Caicos": "🇹🇨",
    Tuvalu: "🇹🇻",
    Uganda: "🇺🇬",
    Uruguay: "🇺🇾",
    Uzbekistan: "🇺🇿",
    Vanuatu: "🇻🇺",
    "Virgin Islands, British": "🇻🇬",
    "Virgin Islands, U.S.": "🇻🇮",
    "Wallis and Futuna": "🇼🇫",
    "Western Sahara": "🇪🇭",
    Yemen: "🇾🇪",
    Zambia: "🇿🇲",
    Zimbabwe: "🇿🇼",
    Réunion: "🇷🇪"
}
